"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContainerLoader_1 = require("./ContainerLoader");
exports.default = ContainerLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ContainerLoader/index.js
// module id = 1123
// module chunks = 8